import { type SVGProps, useEffect, useRef } from 'react';

export function Arrow(props: SVGProps<SVGSVGElement> & { isVisible: boolean }) {
    const { isVisible, ...rest } = props;

    const animateRef = useRef<SVGAnimateElement>(null);
    const animateMotionRef = useRef<SVGAnimateElement>(null);
    const animateBackgroundRef = useRef<SVGAnimateElement>(null);
    const animateMotionBackgroundRef = useRef<SVGAnimateElement>(null);

    useEffect(() => {
        if (isVisible) {
            animateRef.current?.beginElement();
            animateMotionRef.current?.beginElement();
            animateBackgroundRef.current?.beginElement();
            animateMotionBackgroundRef.current?.beginElement();
        }
    }, [isVisible]);
    return (
        <svg width="510" height="370" viewBox="0 0 510 370" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                d="M17 358L117 213.5L225.5 293L306 204L398.5 237.5L484 61.5"
                stroke="#191D3A"
                strokeWidth="20"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="725"
                strokeDashoffset="725">
                <animate ref={animateBackgroundRef} attributeName="stroke-dashoffset" from="725" to="0" dur="2s" fill="freeze" />
            </path>

            <g transform="translate(-473.2 -60)">
                <path
                    d="M498.736 26.9912C500.017 26.1372 501.742 26.9902 501.842 28.5266L505.186 80.3804C505.285 81.9168 503.684 82.9843 502.303 82.302L455.725 59.2712C454.344 58.5888 454.221 56.6683 455.502 55.8143L498.736 26.9912Z"
                    fill="#191D3A"
                />
                <animateMotion
                    ref={animateMotionBackgroundRef}
                    dur="2s"
                    repeatCount="0"
                    path="M10 343L115.076 192.5L224.342 276L303.236 185L393.942 221L473 60.5"
                    fill="freeze"
                />
            </g>
            <path
                fill="none"
                stroke="#2EE69F"
                strokeWidth="20"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="725"
                strokeDashoffset="725"
                d="M10 343L115.076 192.5L224.342 276L303.236 185L393.942 221L473 60.5">
                <animate ref={animateRef} attributeName="stroke-dashoffset" from="725" to="0" dur="2s" fill="freeze" />
            </path>

            <g transform="translate(-473.2 -60)">
                <path
                    d="M491.736 16.9912C493.017 16.1372 494.742 16.9902 494.842 18.5266L498.186 70.3804C498.285 71.9168 496.684 72.9843 495.303 72.302L448.725 49.2712C447.344 48.5888 447.221 46.6683 448.502 45.8143L491.736 16.9912Z"
                    fill="#2EE69F"
                />

                <animateMotion
                    ref={animateMotionRef}
                    dur="2s"
                    repeatCount="0"
                    path="M10 343L115.076 192.5L224.342 276L303.236 185L393.942 221L473 60.5"
                    fill="freeze"
                />
            </g>
        </svg>
    );
}
